import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import DashboardEnhanced from './pages/DashboardEnhanced';
import InventoryListEnhanced from './pages/InventoryListEnhanced';
import InventoryDetail from './pages/InventoryDetail';
import AddInventory from './pages/AddInventory';
import BarcodeScanner from './pages/BarcodeScanner';
import SalesHistory from './pages/SalesHistory';
import LocationManagement from './pages/LocationManagement';
import ReservationManagement from './pages/ReservationManagement';
import ExcelManagement from './pages/ExcelManagement';
import ConsignorSettlement from './pages/ConsignorSettlement';
import AttributeManagement from './pages/AttributeManagement';
import CustomerManagement from './pages/CustomerManagement';
import FilterManagement from './pages/FilterManagement';
import BarcodePrint from './pages/BarcodePrint';
import ZonePriceList from './pages/ZonePriceList';
import Settings from './pages/Settings';
import AlertSettings from './pages/AlertSettings';
import Notifications from './pages/Notifications';
import DataConsistencyCheck from './pages/DataConsistencyCheck';
import DataConsistencyFix from './pages/DataConsistencyFix';
import PrePurchaseList from './pages/PrePurchaseList';
import ContainerPrePurchaseList from './pages/ContainerPrePurchaseList';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout>
                <DashboardEnhanced />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/inventory"
          element={
            <PrivateRoute>
              <Layout>
                <InventoryListEnhanced />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/add"
          element={
            <PrivateRoute>
              <Layout>
                <AddInventory />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/inventory/:id"
          element={
            <PrivateRoute>
              <Layout>
                <InventoryDetail />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/scan"
          element={
            <PrivateRoute>
              <Layout>
                <BarcodeScanner />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/sales"
          element={
            <PrivateRoute>
              <Layout>
                <SalesHistory />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/locations"
          element={
            <PrivateRoute>
              <Layout>
                <LocationManagement />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/reservations"
          element={
            <PrivateRoute>
              <Layout>
                <ReservationManagement />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/excel"
          element={
            <PrivateRoute>
              <Layout>
                <ExcelManagement />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/settlement"
          element={
            <PrivateRoute>
              <Layout>
                <ConsignorSettlement />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/attributes"
          element={
            <PrivateRoute>
              <Layout>
                <AttributeManagement />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/customers"
          element={
            <PrivateRoute>
              <Layout>
                <CustomerManagement />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/filters"
          element={
            <PrivateRoute>
              <Layout>
                <FilterManagement />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/barcode-print"
          element={
            <PrivateRoute>
              <Layout>
                <BarcodePrint />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/zone-price"
          element={
            <PrivateRoute>
              <Layout>
                <ZonePriceList />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <Layout>
                <Settings />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/alerts"
          element={
            <PrivateRoute>
              <Layout>
                <AlertSettings />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/notifications"
          element={
            <PrivateRoute>
              <Layout>
                <Notifications />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/data-consistency"
          element={
            <PrivateRoute>
              <Layout>
                <DataConsistencyCheck />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/data-consistency-fix"
          element={
            <PrivateRoute>
              <Layout>
                <DataConsistencyFix />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/pre-purchase"
          element={
            <PrivateRoute>
              <Layout>
                <PrePurchaseList />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/container-pre-purchase"
          element={
            <PrivateRoute>
              <Layout>
                <ContainerPrePurchaseList />
              </Layout>
            </PrivateRoute>
          }
        />

      </Routes>
    </Router>
  );
}

export default App;
